module.exports = __webpack_public_path__ + "static/media/sx.64d26399.svg";